import { useEffect, useState } from 'react';
import axios from 'axios';
import { Leaf, Star, Egg, Calendar, Home, Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ICONS = {
  leaf: Leaf,
  star: Star,
  egg: Egg,
  calendar: Calendar,
  home: Home,
  sparkles: Sparkles,
};

const ROTATION_MS = 5000;

export default function SitePulseTicker() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [enter, setEnter] = useState(true);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/site-pulse`).then(r => {
      const ticker = r.data?.ticker || [];
      if (ticker.length) setItems(ticker);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const id = setInterval(() => {
      setEnter(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % items.length);
        setEnter(true);
      }, 280);
    }, ROTATION_MS);
    return () => clearInterval(id);
  }, [items.length]);

  if (!items.length) return null;
  const current = items[idx];
  const Icon = ICONS[current.icon] || Sparkles;

  const handleClick = () => {
    if (!current.link) return;
    const el = document.querySelector(current.link);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      data-testid="site-pulse-ticker"
      className="fixed top-0 left-0 right-0 z-[55] bg-[#1A1C19] border-b border-white/5"
    >
      <button
        type="button"
        onClick={handleClick}
        disabled={!current.link}
        className={`group block w-full text-center py-2.5 px-4 text-[11px] md:text-[11.5px] tracking-[0.18em] uppercase text-white/85 transition-opacity duration-300 ${enter ? 'opacity-100' : 'opacity-0'} ${current.link ? 'cursor-pointer hover:bg-white/[0.03]' : 'cursor-default'}`}
      >
        <span className="inline-flex items-center gap-3">
          <Icon className="w-3 h-3 text-[#CBA77A]" strokeWidth={1.8} />
          <span className="font-medium">{current.text}</span>
          {current.link && (
            <span className="text-[#CBA77A] opacity-0 group-hover:opacity-100 transition-opacity ml-1 text-[10px]">→</span>
          )}
        </span>
      </button>
    </div>
  );
}
